// test2054
(2054 && 0);
